// src/components/FieldSelection.js
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './FieldSelection.css';

const FieldSelection = () => {
  const navigate = useNavigate();
  const [selectedField, setSelectedField] = useState('');
  const [isAnimating, setIsAnimating] = useState(false);

  const fields = [
    'Construction Worker',
    'Plumber',
    'Electrician',
    'Carpenter',
    'Painter',
    'Mason',
    'Welder',
    'HVAC Technician',
    'Others...'
  ];

  useEffect(() => {
    setIsAnimating(true);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedField) {
      sessionStorage.setItem('userField', selectedField);
      navigate('/home');
    }
  };

  return (
    <div className={`field-selection-container ${isAnimating ? 'animate-entry' : ''}`}>
      <div className="field-selection-card">
        <div className="selection-header">
          <h2 className="selection-title">Choose Your Expertise</h2>
          <p className="selection-subtitle">Select your primary work field to get relevant job matches</p>
        </div>

        <form onSubmit={handleSubmit} className="selection-form">
          <div className="custom-select-wrapper">
            <select 
              className="custom-select"
              value={selectedField}
              onChange={(e) => setSelectedField(e.target.value)}
              required
            >
              <option value="">Select your field</option>
              {fields.map((field) => (
                <option key={field} value={field}>
                  {field}
                </option>
              ))}
            </select>
            <div className="select-arrow"></div>
          </div>

          <button type="submit" className="btn-theme">
            Continue
          </button>
        </form>

        <div className="progress-indicator">
          <p>Almost There!</p>
          <div className="progress-bar mt-1">
            <div className="progress-fill"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldSelection;